import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, TOKEN_KEY } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(null);
  }, []);

  useEffect(() => {
    const onLogout = () => setUser(null);
    window.addEventListener("sb-logout", onLogout);
    if (!localStorage.getItem(TOKEN_KEY)) setLoading(false);
    else
      api.get("/auth/me").then((r) => setUser(r.data)).catch(() => logout()).finally(() => setLoading(false));
    return () => window.removeEventListener("sb-logout", onLogout);
  }, [logout]);

  const saveSession = (data) => {
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
  };

  const login = async (email, password) => saveSession((await api.post("/auth/login", { email, password })).data);
  const register = async (name, email, password) =>
    saveSession((await api.post("/auth/register", { name, email, password })).data);

  const updateName = async (name) => setUser((await api.put("/auth/me", { name })).data);

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateName }}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
